export default "__VITE_ASSET__74d64323__"